import Vue from 'vue';

const observable = <T>(value: T): T => Vue.observable(Object.assign({}, value));

export default observable;



// WEBPACK FOOTER //
// ./src/pages/profile/store/utils/observable.ts